export default "__VITE_ASSET__DwBCepsn__"